
export class User {    
    constructor(
        public mail: string,
        public password: string,
        public role?: string
    ) { } 
}
